import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";

interface SuperAdminRouteProps {
  children?: React.ReactNode;
}

export const SuperAdminRoute = ({ children }: SuperAdminRouteProps) => {
  const { user, isLoading, isSuperAdmin, platformRoles } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center py-20" data-testid="admin-auth-loading">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  const hasAdminAccess = isSuperAdmin || platformRoles?.isPlatformAdmin;
  if (!hasAdminAccess) {
    return <Navigate to="/app" replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};
